/** The apparatus carrying the camera, independent of lens, gimbal, and authored motion. */
export const CAMERA_PLATFORM_IDS = [
  'aerial-follow',
  'chase',
  'orbit',
  'terrain-reveal',
  'uav',
  'night-hawk',
  'blackbird',
] as const;

export type CameraPlatformId = (typeof CAMERA_PLATFORM_IDS)[number];

/** Behavior version for new platform selections; saved version 3 remains supported. */
export const CAMERA_PLATFORM_VERSION = 4 as const;

/** Convert the historical platform identifier only at saved-data boundaries. */
export function normalizeCameraPlatform(value: unknown): CameraPlatformId | undefined {
  if (value === 'overview') return 'uav';
  return CAMERA_PLATFORM_IDS.find(id => id === value);
}
